import './components';
import Carousel from '../../auto/carousel';

window.Carousel = Carousel;
